import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  align-items: center;
  height: var(--header-height);
`;

export const Right = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const NavButton = styled.a`
  color: ${(props) => (props.isactive ? 'white' : 'black')};
  cursor: pointer;
  padding: 10px 20px;
  text-align: center;
  font-family: 'Gotham-Bold';
  text-transform: uppercase;
  background: ${(props) => (props.isactive ? 'var(--c-light-blue)' : 'white')};
  border: 1px solid ${(props) => (props.isactive ? 'var(--c-light-blue)' : 'white')};

  &:visited {
    color: white;
  }
`;
